import React from 'react';
// import { useState } from 'react';
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom'


import './App.css';

import HomeScreen from './HomeScreen'
import Productions from './Productions'
import Formations from './Formations'
import Contact from './Contact'
import Architecture from './Architecture'


function App() {

return (


  <Router>
  <Switch>
    <Route component={HomeScreen} path="/" exact />
    <Route component={Productions} path="/productions" exact />
    <Route component={Formations} path="/formations" exact />
    <Route component={Contact} path="/contact" exact />
    <Route component={Architecture} path="/architecture" exact />
   

   
  </Switch>
</Router>

)

  



}

export default App;
